:host{display:block}
/*# sourceMappingURL=flip-subscore-graph.component-HL5BL7JU.css.map */
